//Local storage
export const STORAGE_JOBS_NAMESPACE = 'XING::Jobs';
export const LO_APPLICATION_SUBMITTED_STORAGE_PREFIX = 'application-submitted';
export const JOBS_REPORTED_JOBS = `${STORAGE_JOBS_NAMESPACE}.reported.jobs`;

// Recommendations
export const RECOMMENDATIONS_COUNT = 50;

// Search
export const SEARCH_PAGE_SIZE = 20;
export const DEFAULT_RADIUS = 0;
export const RADIUS_OPTIONS = [0, 10, 20, 50, 70, 100, 200];
export const DEFAULT_SORT = 'relevance';
export const MIN_SALARY = 0;
export const MAX_SALARY = 200_000;
export const SALARY_STEP = 1000;
export const SEARCH_STATE_FILTER_PARAMS = {
  // Filters
  benefit: 'benefit',
  careerLevel: 'careerLevel',
  city: 'city',
  company: 'company',
  country: 'country',
  discipline: 'discipline',
  employmentType: 'employmentType',
  industry: 'industry',
  remoteOption: 'remoteOption',
  salary: 'salary',
  // Other query params
  page: 'page',
  sort: 'sort',
  // Radius needs to be counted as a filter
  radius: 'radius',
} as const;
export const SEARCH_STATE_PARAMS = {
  // Inputs
  keywords: 'keywords',
  location: 'location',
  cityId: 'cityId',
  ...SEARCH_STATE_FILTER_PARAMS,
} as const;
export const SEARCH_QUERY_ID_PARAM = 'id';
export const SEARCH_STATE_SEPARATOR = '-';
export const SMALL_SCREEN_BOTTOM_SHEET_PARAM = 'filter_view';
export const SEARCH_COUNT_LOCAL_STORAGE = 'SEARCH_QUERY_COUNT';

// Search alerts
export const MAX_ALERT_COUNT = 40;
export const SEARCH_ALERT_COUNT_PARAM = 'sa_count';
export const SEARCH_ALERTS_MODAL_PARAM = 'sa_modal';
export const REFERRER_ALERT_ID_PARAM = 'referrer_alert_id';
export const SEARCH_ALERTS_MODAL_TYPES = {
  REPEAT: 'repeat',
  CREATE: 'create',
  JOB_DETAILS: 'job_details',
} as const;
export const EDIT_SEARCH_ALERT_PARAM = 'edit_alert';
export const SEARCH_ALERTS_ERROR_BANNER = 'sa_error';
export const SEARCH_ALERTS_ERROR_TYPE = {
  CREATE: 'create',
  DELETE: 'delete',
  DUPLICATED: 'duplicated',
} as const;
export const SEARCH_ALERTS_EMAIL_BANNER_STATE = 'email_banner';

// Recent searches
export const SEARCH_BOX_MAX_RECENT_SEARCHES = 5;

// Generic
export const ORIGIN_PARAM = 'origin';
export const ORIGIN_PARAM_VALUES = {
  searchAlertsFindJobs: 'search_alerts_find_jobs',
  searchAlerts: 'search_alerts',
};

// Layout
export const TOP_BAR_HEIGHT_DESKTOP = 68;
export const TOP_BAR_HEIGHT_MOBILE = 54;
export const TOP_BAR_HEIGHT_MOBILE_LOGOUT = 50;
export const BOTTOM_BAR_HEIGHT = 60;
